/**
 * The different states of the Alyx image at the top of the GameHeader. These
 * are states that are loopable that once set will loop until changed.
 */
const ALEX_STATES = {
    INACTIVE: 0,
    ACTIVE: 1,
    SPEAKING: 2,
};

export default ALEX_STATES;

export const ALYX_FRAMES = {
    // Loops
    INACTIVE: [0, 44],
    INACTIVE_ALT: [45, 90],
    ACTIVE: [360, 430],
    SPEAKING: [97, 220],
    SPEAKING_ALT: [157, 220],
    // Single animations
    CORRECT: [228, 248],
    CORRECT_ALT: [308, 352],
    INCORRECT: [275, 308],
    INCORRECT_ALT: [248, 275],
    // Static "images"
    STATIC_INACTIVE: [0, 20],
    STATIC_ACTIVE: [360, 370],
    STATIC_SPEAKING: [167, 168],
};

export const ALYX_FRAMES_BY_STATE = {
    [ALEX_STATES.INACTIVE]: [ALYX_FRAMES.INACTIVE, ALYX_FRAMES.STATIC_INACTIVE],
    [ALEX_STATES.ACTIVE]: [ALYX_FRAMES.ACTIVE, ALYX_FRAMES.STATIC_ACTIVE],
    [ALEX_STATES.SPEAKING]: [ALYX_FRAMES.SPEAKING, ALYX_FRAMES.STATIC_SPEAKING],
};
